/**
 * Hộp thoại xác nhận theo mục 3.4 đặc tả giao diện.
 *
 * Quy tắc: nội dung NÊU RÕ SỐ ĐỐI TƯỢNG bị ảnh hưởng. Tuyệt đối không dùng câu
 * "Bạn có chắc không?" — câu đó không cho người dùng thêm thông tin nào để quyết.
 * Với hành động không hoàn tác được (xóa thiết bị, phát khẩn cấp, firmware diện
 * rộng), người dùng phải nhập một TỪ XÁC NHẬN trước khi nút được kích hoạt.
 */
import { useEffect, useId, useRef, useState, type ReactNode } from 'react';
import { dienVao, vi } from '../ngon-ngu/vi';

export interface HopXacNhanProps {
  tieuDe: string;
  /** Hệ quả định lượng: phải nêu số thiết bị hoặc đối tượng bị ảnh hưởng. */
  heQua: string;
  /** Ghi chú thêm, ví dụ lệnh đi qua service nhà cung cấp. */
  ghiChu?: string;
  /** Có thì bắt buộc nhập đúng từ này mới bật được nút thực hiện. */
  tuXacNhan?: string;
  nhanThucHien?: string;
  onHuy: () => void;
  onThucHien: () => void;
}

export function HopXacNhan({
  tieuDe,
  heQua,
  ghiChu,
  tuXacNhan,
  nhanThucHien,
  onHuy,
  onThucHien,
}: HopXacNhanProps): ReactNode {
  const [daNhap, datDaNhap] = useState('');
  const idTieuDe = useId();
  const idMoTa = useId();
  const oDau = useRef<HTMLButtonElement | HTMLInputElement | null>(null);

  useEffect(() => {
    oDau.current?.focus();
    const esc = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onHuy();
    };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [onHuy]);

  const batDuoc = !tuXacNhan || daNhap.trim().toUpperCase() === tuXacNhan.toUpperCase();

  return (
    <div className="man-che" role="presentation">
      <div
        className="hop-thoai"
        role="dialog"
        aria-modal="true"
        aria-labelledby={idTieuDe}
        aria-describedby={idMoTa}
      >
        <h2 id={idTieuDe}>{tieuDe}</h2>
        <p id={idMoTa}>{heQua}</p>
        {ghiChu ? <p className="hop-thoai__ghi-chu">{ghiChu}</p> : null}
        {tuXacNhan ? (
          <p className="hop-thoai__tu">
            <label htmlFor="tu-xac-nhan">
              {vi.xacNhan.tuXacNhanNhan}: {dienVao(vi.xacNhan.tuXacNhan, { tu: tuXacNhan })}
            </label>
            <input
              id="tu-xac-nhan"
              ref={(e) => {
                oDau.current = e;
              }}
              value={daNhap}
              onChange={(e) => datDaNhap(e.target.value)}
              autoComplete="off"
            />
          </p>
        ) : null}
        <div className="hop-thoai__nut">
          <button
            type="button"
            className="nut"
            onClick={onHuy}
            ref={(e) => {
              if (!tuXacNhan) oDau.current = e;
            }}
          >
            {vi.xacNhan.huy}
          </button>
          <button
            type="button"
            className="nut nut--chinh"
            data-hanh-dong="xac-nhan-thuc-hien"
            disabled={!batDuoc}
            onClick={onThucHien}
          >
            {nhanThucHien ?? vi.xacNhan.thucHien}
          </button>
        </div>
      </div>
    </div>
  );
}
